import { PIIMaskRules } from '@ringcx/pii-interceptor';

import { LogLevel } from './constants';

export type LogParams = { level: LogLevel; piiMaskRules?: PIIMaskRules; messageParts: any[] };

export abstract class BaseTransport {
    public abstract log(params: LogParams): void;
    public abstract downloadLogs(): Promise<void>;
}
